import{QueryClient}from'@tanstack/react-query';const queryClient=new QueryClient({defaultOptions:{queries:{refetchOnWindowFocus:false,staleTime:60000,// 1 minute
cacheTime:Infinity,retry:false}}});export{queryClient};